<template>
	<el-cascader ref="zArea"
		v-model="zAreaObj.value"
		:options="zAreaObj.options||areaList"
		:props="zAreaObj.props"
		:size="zAreaObj.size"
		:placeholder="zAreaObj.placeholder"
		:disabled="zAreaObj.disabled"
		:clearable="zAreaObj.clearable"
		:show-all-levels="zAreaObj.showAllLevels"
		:collapse-tags="zAreaObj.collapseTags"
		:separator="zAreaObj.separator"
		:filterable="zAreaObj.filterable"
		:filter-method="zAreaObj.filterMethod"
		:debounce="zAreaObj.debounce"
		:before-filter="zAreaObj.beforeFilter"
		:popper-class="zAreaObj.popperClass"
		:expandTrigger="zAreaObj.expandTrigger"
		:multiple="zAreaObj.multiple"
		:lazy="zAreaObj.lazy"
		:lazyLoad="zAreaObj.lazyLoad"
		@change="change"
		@expand-change="expandChange" />
</template>
<script>
	import areaList from './main.json'
	export default {
		name: 'z-area',
		props: {
			zAreaObj: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				areaList,
			}
		},
		methods: {
			// 选中变化
			change(value) {
				this.$emit('zAreaChange', value, this.$refs.zArea.getCheckedNodes()[0])
			},
			// 每一级变化都调用
			expandChange(value) {
				this.$emit('zAreaExpandChange', value, this.$refs.zArea.getCheckedNodes()[0])
			},
		},
	}
</script>
<style lang="scss" scoped>
	.el-cascader{
		width: 100%;
	}
</style>